function handleFilterUpdate(filterGroups) {
  let currentProperty = "";
  let filterString = "";
  let sortBy = document.querySelector('input[name="sort_by"]:checked');
  let activeFilters = [];

  if(sortBy) {
    filterString += "sort_by=";
    filterString += sortBy.value;
  }

  if(filterGroups) {
    filterGroups.forEach(filter => {
      if(filter.checked) {
        if(filter.name !== currentProperty) {
          if(filterString) {
            filterString += "&";
          }
  
          filterString += filter.name + "=" + filter.value
  
          currentProperty = filter.name;
        } else {
          filterString += "," + filter.value;
        }
      }
    })
  } else {
    let filterGroups = document.querySelectorAll(".filter-group input");

    filterGroups.forEach(input => {
      input.checked = false;
    }) 
  }

  const mainCollectionEl = document.querySelector(".collection__window");
  const mainCollectionCount = document.querySelector(".collection-top-bar__product-count");
  mainCollectionEl.classList.add("results-loading");

  let url = window.location.pathname + "?" + filterString + "&" + "section_id=static-collection";
  let collectionPageResEl = document.createElement("div");

  fetch(url)
    .then(response => response.text())
    .then(data => {
      collectionPageResEl.innerHTML = data;

      const newCollectionEl = collectionPageResEl.querySelector(".collection__window");
      const newCollectionCount = collectionPageResEl.querySelector(".collection-top-bar__product-count");
      mainCollectionEl.innerHTML = newCollectionEl.innerHTML;
      mainCollectionCount.innerHTML = newCollectionCount.innerHTML;
    }).then(data => {
      mainCollectionEl.classList.remove("results-loading");
    })
}

document.addEventListener('DOMContentLoaded', function() {
  let filterGroups = document.querySelectorAll(".filter-group input");
  let sortInputs = document.querySelectorAll('input[name="sort_by"]');
  let sortDetails = document.querySelector(".collection-top-bar__filters-inner details");
  let sortSummary = document.querySelector(".collection-top-bar__filters-inner details summary");

  filterGroups.forEach(filter => {
    filter.addEventListener('click', function() {
      handleFilterUpdate(filterGroups)
    })
  })

  sortInputs.forEach(input => {
    input.addEventListener('input', function() {
      handleFilterUpdate(filterGroups);

      sortSummary.innerText = input.dataset.value;
      sortDetails.removeAttribute("open");
    });
  })

  let collectionSidebar = document.querySelector(".collection__sidebar");
  let collectionSidebarToggle = document.querySelector(".collection-top-bar__sidebar-toggle button");
  let collectionSidebarClose = document.querySelector(".collection-sidebar-close");
  let collectionSidebarApplyFilters = document.querySelector(".collection-sidebar-apply");
  let collectionSidebarClearFilters = document.querySelector(".collection-sidebar-clear");


  collectionSidebarToggle.addEventListener('click', function() {
    collectionSidebar.classList.toggle("collection__sidebar--hidden");
  })

  collectionSidebarClose.addEventListener('click', function() {
    collectionSidebar.classList.add("collection__sidebar--hidden");
  })

  collectionSidebarApplyFilters.addEventListener('click', function() {
    collectionSidebar.classList.add("collection__sidebar--hidden");
  })

  collectionSidebarClearFilters.addEventListener('click', function() {
    handleFilterUpdate();

    setTimeout(() => {
      collectionSidebar.classList.add("collection__sidebar--hidden");
    }, 150);
  })
})